import { FC, PropsWithChildren } from "react";
import { useApp } from "./Context/AppContext";
import styles from "./Layout.module.scss";
import { Link, useNavigate } from "react-router";
import { Button, ButtonSize, CenterCover, CoverType, Loading } from "aphrodite.react/Components";
import { HttpStatusCode, Severity } from "aphrodite.react/Helpers";
import { SessionClient } from "./AdminApi/AdminApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { Configuration } from "./Context/Configuration";
import { createPortal } from "react-dom";

export const Layout: FC<PropsWithChildren> = (props) => {
    const { resource, session, refreshSession, isBusy } = useApp();
    const navigate = useNavigate();

    const handleSignOut = async () => {
        const response = await new SessionClient().delete();

        if (response.status === HttpStatusCode.Http204NoContent) {
            await refreshSession();
            navigate("/login");
        }
    };

    return (
        <>
            <div className={styles.topBar}>
                <div className={styles.left}>
                    <span className={styles.text} onClick={() => navigate("/admin")}>
                        {resource("AdminTitle", { 1: resource("ApplicationName") })}
                    </span>
                </div>

                <div className={styles.right}>
                    {!!session && (
                        <>
                            <Link to="/admin/account">
                                {session.name}
                            </Link>
                            <span>
                                <Button
                                    size={ButtonSize.Small}
                                    severity={Severity.Danger}
                                    onClick={() => handleSignOut()}
                                    title={resource("SignOut")}
                                    className="asLink"
                                >
                                    <FontAwesomeIcon icon={faRightFromBracket} />
                                </Button>
                            </span>
                        </>
                    )}
                    <Button
                        size={ButtonSize.Small}
                        onClick={() => window.open(Configuration.get().appUri!, "_blank")}
                        severity={Severity.Secondary}
                    >
                        {resource("ClientApp")}
                    </Button>
                </div>
            </div>

            <div className={styles.content}>
                {props.children}
            </div>

            {isBusy && createPortal(
                <CenterCover
                    backgroundClassName={styles.busy}
                    coverType={CoverType.FullScreen}
                >
                    <Loading size="5x" />
                </CenterCover>,
                document.body
            )}
        </>
    );
};